import { createFileRoute } from '@tanstack/react-router'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'
import { Layout } from '@/components/custom/layout'
import Overview from '@/components/reports-route/agents/overview'
import ReportAgentDetail from '@/components/reports-route/agents/agent-detail'
import { navigateGuard } from '@/utils/auth.js'
import { UserRole } from '@/constants/user.js'
export const Route = createFileRoute('/_auth/report/agent')({
  beforeLoad: ({ location }) =>
    navigateGuard(location, [
      UserRole.ADMINISTRATOR,
      UserRole.SUPERVISOR,
      UserRole.TEAM_LEADER,
    ]),
  component: Agent,
})

const tabs = [
  {
    label: 'Tổng quan',
    value: 'overview',
  },
  {
    label: 'Chi tiết',
    value: 'detail',
  },
]

function Agent() {
  return (
    <Layout.Body>
      <Tabs defaultValue="overview" className="w-full">
        <TabsList>
          {tabs.map((tab) => (
            <TabsTrigger key={tab.value} value={tab.value}>
              {tab.label}
            </TabsTrigger>
          ))}
        </TabsList>
        <TabsContent value="overview">
          <Overview />
        </TabsContent>
        <TabsContent value="detail">
          <ReportAgentDetail />
        </TabsContent>
      </Tabs>
    </Layout.Body>
  )
}
